module.exports = __webpack_public_path__ + "static/media/English.68be774f.svg";